import Cookies from 'js-cookie'
import { setupWebViewJavascriptBridge } from '../utils'
import { mapActions, mapState, mapMutations } from 'vuex'
import AttentionDialog from '../../../views/job-campus-offer/components/attention-notify'

let moment = require('moment')

export const campusMixin = {
	data () {
		return {
			path: '',
			needShare: false
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = to.fullPath
		})
	},
	methods: {
		changeNeedShareValue(type) {
			this.needShare = this.$db.ls.get('shareNeed')
			this.$db.ls.remove('shareNeed')
		},
		collection (item) {
			let _t = Cookies.get('_t')
			this.verifyLogin(_t, this.changeLikeState, this.path, item)
		},
		toDetail (token, name) {
			if (this.isWxMini) {
				this.$wechat.miniProgram.navigateTo({
					url: `/pages/job-campus-detail/job-campus-detail?url=${ process.env.VUE_APP_HOST }/jobs/campus/${ token }&name=${ name }`
				})
			} else {
				this.routeTo(`/jobs/campus/${ token }`)
			}
			// this.$router.push({ path: `/campus/${ token }` })
		},
		async changeLikeState (item) {
			let id = item.comp_recruit_info.id
			let type = item.job_is_liked ? 'dislike' : 'like'
			let params = { comp_recruit_id: id, type }
			let res = await this.$api.jobs.changeLikeState(params)
			if (res.code === 1000 && params.type === 'like') {
				this.showToast('已成功收藏')
				item.job_is_liked = !item.job_is_liked
			} else if (res.code === 1000 && params.type === 'dislike') {
				this.showToast('已取消收藏')
				item.job_is_liked = !item.job_is_liked
			}
		}
	}
}
export const jobsMixin = {
	data () {
		return {
			jobAlertShow: false,
			loadingShow: false,
			loading: true,
			logged: false,
			mailingShow: false,
			cvToken: '',
			pageData: {},
			jobData: {},
			onlineCheckState: false,
			cvIndex: 0,//一键投递需要使用的选中的第几个简历下标
			needShare: false,
		}
	},
	computed: {
		...mapState('cv', [ 'onlineCvData' ]),
		onlineData () {
			let data = this.onlineCvData.resume
			if (data) {
				return [ {
					name: data.info.basic_info.cv_name,
					token: data.token,
					update_at: moment(data.updated_at).format('YYYY年MM月DD日 HH:mm'),
					lang: data.info.basic_info.lang === 'en' ? '英' : '中',
					score: data.info.basic_info.score,
					online: true
				} ]
			} else {
				return []
			}
		},
		cvList () {
			if (this.pageData.cvs) {
				return [ ...this.pageData.cvs ]
			}
		}
	},
	mounted () {
		this.initOnlineCheck()
	},
	methods: {
    ...mapMutations('live', ['setLiveDetailJobList', 'setLiveDelivryList']),
		...mapActions('cv', [ 'getOnlineCvData' ]),
		changeNeedShareValue(type) {
			this.needShare = this.$db.ls.get('shareNeed')
			this.$db.ls.remove('shareNeed')
		},
		// 自定义求职信
		toEmail () {
			window.location.href = process.env.VUE_APP_LINK + this.jobInfo.apply_url.modal_url
		},
		// 在线简历check显示初始化
		async initOnlineCheck () {
			let code = await this.getOnlineCvData(this.cvAccountToken)
			this.onlineCheckState = code === 80120
		},
		// 去除jd中的换行标签
		replaceHtml (val) {
			if (val && this.jobInformation.origin_source === 'jd') {
				val = String(val).replace(/\n/gim, '<br>')
			} else {
				val = String(val).replace(/\n/gim, '<br>').replace(/(<br>\s*)+/gim, '<br>')
			}
			return val
		},
		// 投递确定事件
		async mailing (token, boxChecked, index) {
			this.cvIndex = index
			this._selectCvMailing(token, boxChecked, 'jobDelivery')
		},
		// 更改收藏未收藏
		changeLike (item) {
			this.verifyLogin(this.logged, () => {
				this._changeLike(item)
			}, this.path)
		},
		// 投递点击事件
		sendMailing () {
			// this.verifyLogin(this.logged, this._sendMailing, this.path)
			this.verifyLogin(this.logged, this._sendMailing, window.location.href || this.path)
		},
		// Jd职位操作
		async changeJobsOperation (token, operation) {
			await this.$api.HrApi.jobsOperation({ token, operation })
		},
		// 收藏api请求
		async _changeLike (item) {
			let jobToken = item.token || this.$route.params.token
			let res = await this.$api.jobs.switchLike({
				job_token: jobToken,
				operation: item.is_like ? 'dislike' : 'like'
			})
			if (res.code === 1000) {
				item.is_like = !item.is_like
				if (item && item.is_like) {
					this.toastData = { imgUrl: 'https://files.wondercv.com/jobs/like.png', txt: '职位收藏成功' }
					this.toastShow = true
					if (item.origin_source === 'jd') this.changeJobsOperation(jobToken, 'like')
				} else {
					this.toastData = { imgUrl: 'https://files.wondercv.com/jobs/like.png', txt: '已取消收藏' }
					this.toastShow = true
					if (item.origin_source === 'jd') this.changeJobsOperation(jobToken, 'like_cancel')
				}
				this.$forceUpdate()
				setTimeout(() => {
					this.toastShow = false
					if (this.$route.name === 'recommend-jobs-jd-card') this.changeJobIndex(item)
				}, 1000)
			}
		},
		// 职位投递字数和学历的校验
		async jobDeliveryVerify(jobToken, cvToken) {
			try {
				let res = await this.$api.jobs.jobDeliveryVerify(jobToken, {
					cv_token: cvToken
				})
        if (res.code === 9004 || res.code === 9005 || res.code === 9008 || res.code === 90011) {
        if (res.code === 9004) {
          this.$createDialog({
            type: 'confirm',
            title: '请完善简历内容',
            content: '当前简历完整度较低，请完善至300字以上再进行投递',
            confirmBtn: {
              text: '去完善简历'
            },
            onConfirm: () => {
              this.$router.push(`/cvs/${cvToken}/editor`)
            }
          }).show()
        } else if(res.code === 9005) {
          this.$createDialog({
            type: 'confirm',
            title: res.title,
            content: res.desc,
            confirmBtn: {
              text: '继续投递',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            cancelBtn: {
              text: '再看看',
              active: false,
              disabled: false,
              href: 'javascript:;'
            },
            onConfirm: () => {
              this._selectCvMailing(cvToken, false, 'jobDelivery', false)
            },
            onCancel: async () => {}
          }).show()
        } else if(res.code === 9008) {
					let isCheckGraduationDate = res.title === '毕业时间与职位要求不符' // true校验毕业时间弹框模式，否则false
          this.$createDialog({
            // type: 'confirm',
            type: isCheckGraduationDate ? 'alert' : 'confirm',
            title: res.title,
            content: res.desc,
            confirmBtn: {
              text: isCheckGraduationDate ? '我知道了' : '继续投递',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            cancelBtn: {
              text: '再看看',
              active: false,
              disabled: false,
              href: 'javascript:;'
            },
            onConfirm: () => {
							if (isCheckGraduationDate) return // 校验毕业时间时直接关闭弹框，不再额外执行其他业务逻辑
              this._selectCvMailing(cvToken, false, 'jobDelivery', false)
            },
            onCancel: () => {}
          }).show()
        } else if(res.code === 90011) {
          this.$createDialog({
            type: 'confirm',
            title: res.title,
            content: res.desc,
            confirmBtn: {
              text: '我知道了',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            cancelBtn: {
              text: '取消',
              active: false,
              disabled: false,
              href: 'javascript:;'
            },
            onConfirm: () => {},
            onCancel: () => {}
          }).show()
        }
        return 'error send'
      }
			} catch (e) {
				console.log(e)
			}
		},
		// 投递弹窗tips验证
		async verifyTips(jobToken, cvToken) {
			try {
				let res = await this.$api.jobs.jobDeliveryTips(jobToken)
				if (res.code === 9011 && res.data && res.data.title && res.data.text) {
					this.$createDialog({
            type: 'confirm',
            title: res.data.title,
            content: res.data.text,
            confirmBtn: {
              text: '去改简历',
              active: true,
              disabled: false,
              href: 'javascript:;'
            },
            cancelBtn: {
              text: '继续投递',
              active: false,
              disabled: false,
              href: 'javascript:;'
            },
            onConfirm: () => {
              location.href = `${location.origin}/cvs/${cvToken}/editor`
            },
            onCancel: () => {
							this._selectCvMailing(cvToken, false, 'jobDelivery', false, false)
						}
          }).show()
				}
				return res.code === 9011 ? 'error' : ''
			} catch (e) {
				return 'error'
			}
		},
		// 投递api请求
		async _selectCvMailing (token, boxChecked, source, needVerify = true, verifyTips = true) {
			let { origin_source } = this.jobInformation
			let { need_intern_info } = this.pageData
      let live_token = this.$route.query.live_token || this.$route.params.token
			if (token) {
				let payload = {
					cv_token: token,
					// job_token: this.$route.params.token,
					application_id: this.pageData.job_application && this.pageData.job_application.id,
					cv_source: 'm_job_detail'
				}
				if (this.$route.name === 'recommend-jobs-jd-card') {
					payload.job_token = this.jdList[this.jobIndex].token
					payload.application_id = this.jobApplicationId
				}
        let jobToken = null
        // 直播投递
        if (live_token) {
          jobToken = this.jobInformation.token
        // 普通投递
        } else {
				  jobToken = this.$route.params.token || this.jdList[this.jobIndex].token
        }
				this.mailingShow = false
				if (needVerify) {
					this.cvToken = token
					if (await this.jobDeliveryVerify(jobToken, token) === 'error send') {
						return
					}
				}
				if (verifyTips) {
					if (await this.verifyTips(jobToken, token) === 'error') {
						return
					}
				}
				this.loadingShow = true
				if (!boxChecked) {
					this.$db.ls.set(`${ this.cvAccountToken }-mailing-checked`, true)
				} else if (boxChecked) {
					await this.$api.online.createOnlineCv({ token })
				}
				if (origin_source === 'shixiseng' && need_intern_info) {
					this.$router.push(`/jobs/mailing/practice?jobToken=${ jobToken }&cvToken=${ token }`)
					return
				} else if (origin_source === 'jd') {
					let urlRes = await this.$api.cv.downloadCv(token, { watermark: 'yes' })
					if (urlRes.code === 1000) payload.cv_url = urlRes.data.url
				}
        let res = null
        // 直播投递
        if (live_token) {
          payload.live_token = live_token
				  res = await this.$api.jobs.jobDelivery(jobToken, payload)
        // 普通投递
        } else {
          res = await this.$api.jobs.jobDelivery(jobToken, payload)
        }
				// if (this.jobInfo.apply_url.url === '#deliver-cv') {
				// 	res = await this.$api.jobs.duomianMailing(payload)
				// } else if (this.jobInfo.apply_url.url === '#job-deliver-email') {
				// 	let urlRes = await this.$api.cv.downloadCv(token, { watermark: 'yes' })
				// 	if (urlRes.code === 1000) payload.cv_url = urlRes.data.url
				// 	res = await this.$api.jobs.emailJobDeliver(payload)
				// }

        // 直播投递
        if (live_token) {
          if (res.code === 1000) {
            this.loadingShow = false
            this.showToast('投递成功')
            // 更新直播职位列表
            // this.$api.live.getLiveDetailJobs(live_token, {page: 1, size: 30}).then(res=>{
            //   if(res.code === 1000){
            //     // 同步直播相关职位
            //     this.setLiveDetailJobList(res.data.jobs)
            //   }
            // })
            // 更新用户已投递直播职位列表
            this.$api.live.getLiveDelivryList(live_token).then(res=>{
              if(res.code === 1000){
                // 同步用户投递职位列表
                this.setLiveDelivryList(res.data.jobs)
              }
            })
          }
        // 普通投递
        } else {
          if (res.code === 1000) {
            this.reportedData({
              data_type: 'job_delivery',
              data: {
                job_tokens: [ jobToken ],
                record_key: source,
                record_url: window.location.href
              }
            })
            this.loadingShow = false
            // 判断是否有推荐职位决定是否显示一键投递弹窗
            if (this.recommend.length) {
              this.successState = true
            } else {
              this.toastData = { imgUrl: 'https://files.wondercv.com/jobs/mailing.png', txt: '投递成功' }
              this.toastShow = true
            }
            // 成功后显示投递成功
            setTimeout(() => {
              this.toastShow = false
              if (this.$route.name === 'recommend-jobs-jd-card') {
                this.changeJobIndex({ token: this.jdList[this.jobIndex].token })
              }
            }, 1000)
            if (this.$route.name === 'recommend-jobs-jd-card') {
              this.jdList[this.jobIndex].is_apply = true
              this.changeJobsOperation(jobToken, 'apply')
            } else {
              if (origin_source === 'jd') this.changeJobsOperation(jobToken, 'apply')
              this.jobInfo.apply_url = {
                url: null,
                text: '已投递'
              }
            }
          } else if (res.code === 9010) {
            this.showToast('该职位已下线<br>请尝试其他职位')
            this.loadingShow = false
          } else {
            this.loadingShow = false
          }
        }

			} else {
				this.showToast('请选择简历')
			}
		},
		// 投递弹窗出现逻辑
		_sendMailing () {
			if (this.jobInfo.apply_url.text === '已投递' || this.jobInfo.apply_url.text === '投递已结束') {
				this.$db.ls.set('shareNeed', true)
				this.$router.push({ path: '/welcome/to_app', query: { type: 'person' } })
			} else {
				let { apply_url: { url } } = this.jobInfo
				if (url === '#job-deliver-alert') {
					// this.jobAlertShow = true
					this.mailingShow = true
				} else if (this.cvList && this.cvList.length === 1) {
					let { token } = this.cvList[0]
					this.mailing(token, false, 0)
				} else {
					this.mailingShow = true
				}
			}
			// if (this.jobInfo.apply_url && this.jobInfo.apply_url.url.includes('#')) {
			// 	if (this.jobInfo.apply_url.url === '#deliver-cv' || this.jobInfo.apply_url.url === '#job-deliver-email') {
			// 		this.mailingShow = true
			// 	} else if (this.jobInfo.apply_url.url === '#job-deliver-alert') {
			// 		this.jobAlertShow = true
			// 	}
			// } else {
			// 	window.location.href = process.env.VUE_APP_LINK + this.jobInfo.apply_url.url
			// }
		},
		// 获取登录状态
		verifyLogged () {
			if (Cookies.get('_t')) {
				this.logged = true
			}
		},
		// 不感兴趣接口
		async dislike (item) {
			let res = await this.$api.jobs.switchLike({
				job_token: item.token,
				operation: item.is_discard ? 'rollback' : 'discard',
			})
			if (res.code === 1000) {
				this.jobApplicationId = res.job_application_id
				item.is_discard = !item.is_discard
				this.$forceUpdate()
				if (item.is_discard) {
					this.changeJobsOperation(item.token, 'discard')
					this.showToast('已标记不感兴趣，<br>我们将减少此类职位推荐', 1000)
				} else {
					this.changeJobsOperation(item.token, 'discard_cancel')
					this.showToast('已取消不感兴趣', 1000)
				}
				setTimeout(() => {
					this.changeJobIndex(item)
				}, 1000)
			}
		},

	}
}
export const campusOfferMixin = {
	data() {
		return {
      companyName: '',
			attentionState: false,
		}
	},
	computed: {
		...mapState('campusOffers', ['weekThingsData']),
	},
	components: {
		AttentionDialog
	},
	methods: {
		...mapMutations('campusOffers', {
      setAllWeekThings: 'SET_ALL_WEEK_THINGS'
    }),
		changeAttentionState() {
			this.attentionState = !this.attentionState
		},
    changeCompanyName (name) {
      this.companyName = name
    },
		// 关注弹窗点击我知道了
		toCampusManage() {
			if (this.isWxMini) {
				this.$wechat.miniProgram.switchTab({
					url: '/pages/campusCalendar/campusCalendar'
				})
			} else {
				this.$router.replace('/jobs/campus/manage')
			}
		},
		async campusOfferCollect(data) {
			if (this.alreadyLogged) {
				let res = await this.$api.jobs.getTeamInfo()
				let completed = false
				if(res.code === 1000){
					completed = res.data.completed
					if(!completed){
						if (this.isWxMini) {
							this.$wechat.miniProgram.navigateTo({
								url: `/pages/fission/fission`
							})
							return
						}
					}
				}
				let { subscribe } = this.userData
				const MP_LINK = 'https://mp.weixin.qq.com/s/FVcFkx7vGHYlVfPyo4cTJg'
				const routerFn = () => {
					if (this.isWxMini) {
						this.$wechat.miniProgram.navigateTo({
							url: `/pages/freeUrl/freeUrl?url=${MP_LINK}`
						})
					} else {
						window.location.href = MP_LINK
					}
				}
				if (!subscribe && !data.job_is_liked) {
					this.$api.user.getUserAccountInfo(this.cvAccountToken).then(res => {
						if (res.code === 1000) {
							res.data.subscribe ? this.updateCampusLiked(data) : routerFn()
						}
					}).catch(e => console.log(e))
				} else {
					this.updateCampusLiked(data)
				}
			} else {
				this.needLogin()
			}
		},
		async updateCampusLiked(data) {
			const moment = require('moment')
			let { token } = this.$route.params
			let payload = {
				type: data.job_is_liked ? 'dislike' : 'like'
			}

      // 关注校招和关注公司用同一个接口
      let res = null;
      try {
        if (!data.job_is_liked) {
          // 关注
          res = await this.$api.campusOffers.favoriteCompany({company_token: data.company_token, comp_recruit_token: data.token});
        } else {
          // 关注
          res = await this.$api.campusOffers.unFavoriteCompany(data.company_token);
        }

        if (res.code === 1000) {
          this.showToast(payload.type === 'like' ? '关注成功' : '已取消关注', 1500)
          data.job_is_liked = !data.job_is_liked
          if (token) {
            this.getCampusRecruitmentInfos()
          }
          let currentTime = moment().format('YYYYMMDDHHmmss')
          let startTime = moment(data.start_time).format('YYYYMMDDHHmmss')
          let execDateSunday = startTime < currentTime ? moment().startOf('weeks').format('YYYY-MM-DD') : moment(data.start_time).startOf('weeks').format('YYYY-MM-DD')
          this.setAllWeekThings({ ...this.weekThingsData, [execDateSunday]: undefined })
          const showAttentionDialog = this.$db.ls.get('showAttentionDialog')
          if (data.job_is_liked && res?.data?.first_to_do) {
            this.companyName = data.company_name
            this.$emit('changeAttentionState')
            this.$emit('changeCompanyName', data.company_name)
            this.$db.ls.set('showAttentionDialog', 1)
          }
          this.$forceUpdate()
        } else {
          this.showToast(res.message)
        }
      } catch (err) {
        console.log(err);
      }

		}
	},
	filters: {
		jobLikeFilter(val) {
			return val ? '已关注' : '关注'
		},
		cityFilter(val) {
			if (val && val.length) {
				let cityStr = ''
				val.forEach((item, index) => {
					if (index < 2) cityStr += `${ item }、`
				})
				return val.length > 2 ? cityStr.slice(0, -1) + '等' : cityStr.slice(0, -1)
			} else {
				return '全国'
			}
		},
		recommendFilter(val) {
			return val ? '可内推' : ''
		}
	}
}
